import { OrderByItem } from "../../../api/bigQuery/pharmaStpFileOrders";
import { FilterGroup } from "./buildNycbsSearchFilters";

/** Default sort order for NYCBS External table API requests. */
export const NYCBS_EXTERNAL_DEFAULT_ORDER_BY: OrderByItem[] = [
  { column: "filename", direction: "DESC" },
  { column: "patient_mrn", direction: "ASC" },
  { column: "drug", direction: "ASC" },
];

/** Request payload shape for NYCBS External BigQuery table fetches. */
export interface NycbsExternalFilterPayload {
  org_id: string;
  date_from_filename_start?: string;
  date_from_filename_end?: string;
  filters?:
    | Record<string, string[] | null>
    | FilterGroup
    | Record<string, unknown>;
  case_sensitive?: boolean;
  page: number;
  page_size: number;
  request_id?: string;
  order_by?: OrderByItem[];
}
